import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import{ getConditionalRowStyles, customExpandableIcon, RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js';  
import paymentMethodsService from '../../../services/payment-methods.service.js';
import { listAdminPayments } from "./../../../actions/payment-method-actions.js";
import Confirmation from '../../common/modals/confirmation.component.js';
import ExpandedComponent from "./row-expand.component.js";

const AdminPayments = () => { 
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const [dataTableKey, setDataTableKey] = useState(0);
  const [paymentList, setPaymentList] = useState([]);

  const [expanded, setExpanded] = useState({});

  const [modalShow, setModalShow] = React.useState(false);
  const [row, setRow] =  useState({});


  const listPayments = () => {
    setLoading(true);
    dispatch(listAdminPayments())
      .then(response => {
        setPaymentList( response.data);
        console.log(response.data)
        setLoading(false);
        
      })
      .catch(error => {
        console.log(error)
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
  }



  const changeStatus = (row) => {
    setModalShow(true)
    setRow({
      id: row.id,
      status: row.status_id,
      modalId: 'statusChangePayment'
    })
  }

  const checkStatus = (name,row) => {
      if(name == 'A') {

        return (<label className="switch"  style={{ padding: row.id && !!expanded[row.id] ? '0' : '3px' }} onClick={(event) => {
          event.preventDefault(); // Prevent the default action
          changeStatus(row); // Call your changeStatus function
        }}>
        <input type="checkbox" className="switch-input"  checked />
        <span className="switch-label" data-on="Active" data-off="Deactive" />
        <span className="switch-handle" />
      </label>)
      } else {
        return (

          <div data-tag="allowRowEvents"><label className="switch" onClick={(event) => {
            event.preventDefault(); // Prevent the default action
            changeStatus(row); // Call your changeStatus function
          }}><input type="checkbox" className="switch-input" /><span className="switch-label" data-on="Active" data-off="Deactive" /><span className="switch-handle" /></label></div>
        );
      }
  }

  const columns = [
    {
      name: 'Payment Type',
      selector: row => row.description ,
      sortable: true,
    },
    // {
    //   name: 'Wallet App',
    //   selector: row => paymentName(row.code, 'checkImage') ,
    //   sortable: true,
    // },
    // {
    //   name: 'Mobile Number',
    //   selector: row => row.inst_mobile,
    //   sortable: true,
    // },
    {
      name: 'Status',
      selector: row => checkStatus(row.status_id, row),
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_on,
      sortable: true,
    },
    {
      name: 'Updated At',
      selector: row =>  row.updated_on,
      sortable: true,
    },

  ];



 useEffect(() => {
    if (paymentList?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("even-transaction-table");
        } else {
          childElement[i].classList.add("odd-transaction-table");
        }
      }
    }
  }, [paymentList]);
  const suspendPaymentMethod= (suspended) => {
    setLoading(true);
    paymentMethodsService.suspendPaymentMethod(suspended)
      .then(response => {
        toast.success('Payment Method suspended successfully.');
        listPayments();
        setLoading(false);
        setModalShow(false)
      })
      .catch(error => {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        setLoading(false);
       
      });
 
  }

  const resumePaymentMethod = (resume) => {
    setLoading(true);

    paymentMethodsService.resumePaymentMethod(resume)
      .then(response => {
        toast.success('Payment Method resume successfully.');
        listPayments();
        setLoading(false);
        setModalShow(false)
      })
      .catch(error => {
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
        setLoading(false);
      });
  }

  const updateStatus = () => {
    console.log(row)
    setLoading(true);

    if(row.modalId == 'deletePayment') {
      paymentMethodsService.deletePayment(row.id)
      .then(response => {
        toast.success('payment method deleted successfully.')
        listPayments();
        setModalShow(false)
        setLoading(false);
  
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
    } else {
      if(row.status.toLowerCase() == 'a') {
        suspendPaymentMethod(row.id);
      } else {
        resumePaymentMethod(row.id);
      }
    }

    
  }

  const conditionalRowStyles = [
    {
      when: data => data.id && !!expanded[data.id],
      style: {
        backgroundColor: '#3280dd !important',
        color: 'white',
      },
    },
  ];
  const customExpandableIcon = {
    collapsed: <span className='collapsed-icon'></span>,
    expanded: <span className='expand-icon'></span>,
  };
  const handleRowExpand = (row, data) => {
    const newExpanded = { ...expanded };
    newExpanded[data.id] = !expanded[data.id];
    setExpanded(newExpanded);
  };

    useEffect(() => {
      listPayments();
      document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        
        return () => {
          document.body.style.backgroundColor = '';
        };
      }, []);

      return(
        <>
        <LoaderOverlay loading={loading} />
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>System Payment Methods</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
         
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane active show fade" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                        <div id="examplemgm_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={paymentList}
                              // expandableRows
                              conditionalRowStyles={conditionalRowStyles}
                              customStyles={customDataTableStyles}

                              
                              
                        />

                          </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
    
          </div>
        </div>
        <Confirmation  show={modalShow} onHide={() => setModalShow(false)} onSave={() => updateStatus(false)} status={row.status} modalId = {row.modalId}></Confirmation>
      </div>
      </>
)

}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(AdminPayments));
